"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ExchangeRateDateRuleFields = class ExchangeRateDateRuleFields extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    addRule(...args) {
        const [id] = args;
        const obj = _.find(this.rules, { id });
        if (obj) {
            _.extend(this.item, obj.rule);
            this.setData('selectedRuleID', null);
        }
        this.$emit("input", this.item);
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    item;
    async $$load_item() {
        return this.value || {};
    }
    labelAlign;
    rule_type;
    rules;
    async $$load_rules() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'billing-rule' } })
            .then(items => _.chain(items).filter({ rule_type: this.rule_type }).value());
    }
    metadata;
    async $$load_metadata() {
        return this.$app.repo.get('ui_metadata');
    }
    selectedRuleID;
    ux;
    dataMembers = ['item', 'labelAlign', 'rule_type', 'rules', 'metadata', 'selectedRuleID', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                labelAlign: "right",
                rule_type: "exchange_rate_date",
                rules: null,
                metadata: null,
                selectedRuleID: null,
                ux: null,
            },
        };
    }
    get referenceMonthOptions() {
        if (this.loaded) {
            return this.metadata.exchange_rate_date_reference_month_options;
        }
        return null;
    }
    get daySpecifierOptions() {
        if (this.loaded) {
            return this.metadata.exchange_rate_date_day_specifier_options;
        }
        return null;
    }
    async act_4207795475682514_script_6652_getActionArgs_value($event) {
        this.addRule(this.selectedRuleID);
    }
    async act_4207795475682514_script_6652_getActionArgs($event) {
        return {
            value: () => this.act_4207795475682514_script_6652_getActionArgs_value($event),
        };
    }
    async evh_4207795475682514_click(event, scope) {
        return await this.actions.evh_4207795475682514_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_4207795475682514_script_6652 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4207795475682514_script_6652_getActionArgs,
            events: [],
        });
        const evh_4207795475682514_click_6651 = new core_1.actions.EventHandlerImpl({
            action: act_4207795475682514_script_6652,
            event: "click",
            displayName: "script",
        });
        const evh_4207795475682514_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4207795475682514_click_6651],
        });
        return {
            act_4207795475682514_script_6652,
            evh_4207795475682514_click_6651,
            evh_4207795475682514_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ExchangeRateDateRuleFields.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateDateRuleFields.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ExchangeRateDateRuleFields.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateDateRuleFields.prototype, "onReadonly", null);
ExchangeRateDateRuleFields = __decorate([
    (0, vue_property_decorator_1.Component)()
], ExchangeRateDateRuleFields);
exports.default = ExchangeRateDateRuleFields;
vue_property_decorator_1.Vue.component("ExchangeRateDateRuleFields", ExchangeRateDateRuleFields);
